export { SentimentWarningIcon } from './sentiment-warning-icon';
